import { useTranslation } from 'react-i18next';

export default function WhatsAppSticky() {
  const { t } = useTranslation();
  const message = encodeURIComponent(t('whatsapp.message'));

  return (
    <div>
      {/* Mobile sticky bottom bar */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-dark-100 shadow-lg">
        <a
          href={`https://wa.me/905313459987?text=${message}`}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center gap-2 w-full bg-champagne-500 text-dark-950 py-3.5 font-semibold text-sm hover:bg-champagne-400 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-whatsapp-line text-lg" />
          {t('whatsapp.cta')}
        </a>
      </div>

      {/* Desktop floating button */}
      <a
        href={`https://wa.me/905313459987?text=${message}`}
        target="_blank"
        rel="noopener noreferrer"
        className="hidden md:flex fixed bottom-6 right-6 z-50 items-center gap-2 bg-champagne-500 text-dark-950 px-5 py-3 rounded-full font-semibold text-sm hover:bg-champagne-400 transition-all hover:shadow-lg whitespace-nowrap cursor-pointer group"
      >
        <span className="w-8 h-8 flex items-center justify-center rounded-full bg-dark-950 text-white">
          <i className="ri-whatsapp-line text-base" />
        </span>
        <span className="max-w-0 overflow-hidden group-hover:max-w-[200px] transition-all duration-300 whitespace-nowrap">
          {t('whatsapp.floatingLabel')}
        </span>
      </a>
    </div>
  );
}